export const FETCH_INVENTORY_GROUP = "FETCH_INVENTORY_GROUP"